module.exports = __webpack_public_path__ + "img/start.d85576ce.png";